import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from "@angular/core";

import { ICellEditorAngularComp } from "ag-grid-angular";

@Component({
    selector: 'textarea-cell',
    templateUrl: 'g-textarea.component.html',
    styleUrls: ['g-textarea.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AGTextAreaEditorComponent implements ICellEditorAngularComp, AfterViewInit {
    private params: any;
    public value: string;

    @ViewChild('textarea') public textarea: ElementRef<HTMLTextAreaElement>;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
    }

    getValue(): any {
        return this.value;
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        setTimeout(() => {
            this.textarea.nativeElement.focus();
        })
    }
}